import { Link } from "react-router-dom";
import "./Contact.css";
import { useEffect } from "react";
import gsap from "gsap";
import CV from "../../CV/Sanyam Jain CV.pdf";
var Contact = function () {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from("#Contact_ba", { duration: 1, opacity: 0, x: "-100%" });
    tl.from("#I_am_currently_available_for_b", {
      duration: 1,
      opacity: 0,
      y: "-50%",
    });
    tl.from("#Hire_Me", { duration: 1, opacity: 0, y: "100%" });
  }, []);

  return (
    <div>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Contact</title>
      <link
        rel="stylesheet"
        type="text/css"
        id="applicationStylesheet"
        href="Contact.css"
      />
      <div id="Contact">
        <div id="menu">
          <div id="menu_text">
            <span className="menuItems">
              <Link to="/">Home</Link>
            </span>
            <span className="menuItems">
              <Link to="/about">About</Link>
            </span>
            <span className="menuItems">
              <Link to="/work">Works</Link>
            </span>
            <span className="menuItems" style={{ fontSize: "2rem" }}>
              <Link to="/contact">Contact</Link>
            </span>
          </div>
        </div>
        <div id="Contact_ba">
          <span>Contact</span>
        </div>
        <div id="I_am_currently_available_for_b">
          <div>
            <div>
              I am currently available for both full-time job and freelancing
              work. You can have a look at my resume to know more about me.
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={() => {
          window.open(CV);
        }}
        id="Hire_Me_Contact"
      >
        <span id="HMspan">Get My Resume</span>
      </div>
    </div>
  );
};
export default Contact;
